import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { mentorDashboardNotificationCallback } from '../../utils/mentordashboard'

export default (user, orgId, isMentor, courses, pastCourses) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (user && orgId && isMentor) {
      let mdChannel = window.oeQwPusherInstance.subscribe(
        `quest.organizations.${orgId}.mentors`
      )

      mdChannel.bind(
        'approval_requested',
        mentorDashboardNotificationCallback,
        {
          dispatch,
          courses,
          pastCourses
        }
      )

      mdChannel.bind(
        'mentor_unread_quest_message',
        mentorDashboardNotificationCallback,
        {
          dispatch,
          courses,
          pastCourses
        }
      )

      mdChannel.bind(
        'mentor_notifications_updated',
        mentorDashboardNotificationCallback,
        {
          dispatch,
          courses,
          pastCourses,
          refresh: false
        }
      )

      mdChannel.bind(
        'mentor_activity_focus_skill_check',
        mentorDashboardNotificationCallback,
        {
          dispatch,
          courses,
          pastCourses
        }
      )

      mdChannel.bind(
        'mentor_activity_artifact_assessment',
        mentorDashboardNotificationCallback,
        {
          dispatch,
          courses,
          pastCourses
        }
      )

      return () => {
        mdChannel.unbind('approval_requested')
        mdChannel.unbind('mentor_unread_quest_message')
        mdChannel.unbind('mentor_notifications_updated')
        mdChannel.unbind('mentor_activity_focus_skill_check')
        mdChannel.unbind('mentor_activity_artifact_assessment')
      }
    }
  }, [user, orgId, isMentor, dispatch, courses, pastCourses])
}
